/**
 * @copyright (C) 2023-2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-08-03 14:59:12
 **/

import styled from "@emotion/styled";
import { Column, Row } from "@/frameworks/designStuff/components";

export const HeaderIconList = styled(Row.div)`
	gap: 3px;
`;

export const ReceivePopupWrapper = styled(Column)`
	padding: 16px 12px 12px 12px;
	width: 416px;

	background-color: ${({ theme }) => theme.colors.neutral_80_90};
	border-radius: 12px;
`;

export const CallInfoWraper = styled(Column)`
	padding-top: 12px;
`;

export const SelectWrapper = styled(Column)`
	background-color: ${({ theme }) => theme.colors.neutral_00_100};
	border-radius: 8px;
	padding: 8px;
`;

export const FullSizeWrapper = styled(Column)`
	width: 100vw;
	height: calc(100vh - 60px);
	background-color: ${({ theme }) => theme.colors.neutral_80_90};
`;

export const FullSizeHeader = styled(Row)`
	width: 100%;
	padding: 12px 16px;
	background-color: ${({ theme }) => theme.colors.neutral_80_90};
	backdrop-filter: "blur(20px)";
`;

export const Divider = styled.div`
	border-left: 1px solid ${({ theme }) => theme.colors.neutral_00_16};
	margin: 0 16px;
	height: 30px;
`;
